import { storage } from "@/lib/storage";
import { dayNumber } from "@/lib/daily";

const VISITS_KEY = "atlas.visitDays";
const STREAK_KEY = "atlas.dailyStreak";
export const INSTALL_NUDGE = "atlas:install-nudge";

/** Records today as a visit day; returns the number of distinct days visited (max 30 kept). */
export function recordVisit() {
  const today = dayNumber();
  const days = (storage.getJSON(VISITS_KEY, []) || []).filter((d) => Number.isInteger(d));
  if (!days.includes(today)) storage.setJSON(VISITS_KEY, [...days, today].slice(-30));
  return new Set([...days, today]).size;
}

export const visitDays = () => (storage.getJSON(VISITS_KEY, []) || []).length;

export const nudgeInstall = () => window.dispatchEvent(new Event(INSTALL_NUDGE));

export const dailyResultKey = (day) => `atlas.daily.${day}`;
export const readDaily = (day) => storage.getJSON(dailyResultKey(day), null);

export const readStreak = () => storage.getJSON(STREAK_KEY, { last: null, count: 0 }) || { last: null, count: 0 };

/** Call once when a challenge is completed; keeps the 🔥 streak of consecutive days. */
export function saveDaily(day, picks) {
  const score = picks.filter(Boolean).length;
  storage.setJSON(dailyResultKey(day), { picks, score });
  const s = readStreak();
  const count = s.last === day ? s.count : s.last === day - 1 ? s.count + 1 : 1;
  const next = { last: day, count };
  storage.setJSON(STREAK_KEY, next);
  return { score, streak: count };
}

/** Streak still alive = played today or yesterday. */
export const liveStreak = () => {
  const s = readStreak();
  return s.last !== null && s.last >= dayNumber() - 1 ? s.count : 0;
};

export const streakLabel = (t, n) => (n === 1 ? t("daily_streak_one") : t("daily_streak").replace("{n}", n));
